.select {
  height: 40px;
  padding: 0 16px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #c1b9b9;
  background-color: #ffffff;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  outline: none;
  transition: border-color 0.2s ease;
}

.select:focus {
  border-color: #007bff;
}

.select:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.select option {
  font-size: 14px;
  color: #333;
  padding: 8px;
}
